const rdatez = require('./dist/js/react-datez.js')

module.exports = {
    ReactDatez: rdatez.ReactDatez,
    ReduxReactDatez: rdatez.ReduxReactDatez
}



//////////////////
// WEBPACK FOOTER
// ./~/react-datez/index.js
// module id = 646
// module chunks = 0